import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const params = new URLSearchParams(document.location.search);
const l = params.get('l') ?? params.get('lang');

// TODO meg a browser language-et is hasznalhatnank
// TODO miert 'hu' ha nincs mas es 'en' a default ?
const language = l || localStorage.getItem('language') || 'hu';
const defaultLanguage = 'en';

i18n
  // FIXME .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: language,
    load: 'languageOnly',
    backend: {
      loadPath: (BASE || '/') + 'i18n/{{lng}}.json?v=' + VERSION,
    },
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: true,
    },
  })
  .catch(() => {
    console.error('Could not initialize i18n');
    // now what ?
  });

export default i18n;
